<!-- Search and mode selection -->
<div class="mb-6 flex w-full items-center justify-between gap-4">
  <oiq-form-input
    #nameInputRef="OiqFormElement"
    placeholder="Search Client"
    [formControl]="nameInputCtrl"
    prefixIcon="search"
    class="min-w-96"></oiq-form-input>
  @if (canCreate()) {
    <button
      class="oiq-button oiq-button--primary--outline"
      (click)="event.emit({ action: 'create' })">
      Add New Client
    </button>
  } @else {
    <span>&nbsp;</span>
  }
</div>

<div class="space-y-2">
  @if (clientResults$ | async; as clientResults) {
    @if (clientResults.length === 0 && nameInputCtrl.value) {
      <!-- Client search results with accordion expansion -->
      <div class="no-results">
        <p>No clients found matching your search criteria.</p>
      </div>
    } @else if (clientResults.length > 0) {
      @let _expandedElements = expandedElements();
      @for (client of clientResults; track client.id) {
        <oiq-ui-panel
          #panelRef="OiqUiPanel"
          [titleText]="client.name"
          (event)="handlePanelEvent($event, client)"
          [collapsable]="true"
          [initialyCollapsed]="true"
          class="oiq-ui-panel__reverse oiq-ui-panel__hoverable group shadow-none">
          <ng-template #panelRight>
            <div
              class="flex w-full flex-nowrap items-center justify-between"
              (click)="panelRef.handleToggle()">
              <div class="client-info">
                <div>
                  <span>ID:&nbsp;</span>
                  <span class="font-medium">{{ client.id }}</span>
                </div>
                <div>
                  <span>ISO:&nbsp;</span>
                  <span class="font-medium">{{ client.isoName || 'N/A' }}</span>
                </div>
              </div>

              <div class="flex flex-nowrap items-center gap-x-3">
                <span class="whitespace-nowrap text-xs text-gray-1">{{ client.date }}</span>
                @if (enableSelectClient()) {
                  <button
                    class="oiq-button oiq-button--primary--solid btn-sm none group-hover:visible group-hover:inline-block"
                    [ngClass]="{ invisible: this.expandedElements !== client }"
                    (click)="
                      this.event.emit({ action: 'select', data: { client } });
                      $event.stopPropagation()
                    ">
                    Select
                  </button>
                }
              </div>
            </div>
          </ng-template>
          <div class="p-4">
            <h3 class="mb-2 font-medium">Applications</h3>
            <oiq-client-application-history-table
              [clientId]="_expandedElements[client.id] ? client.id : null"
              [enableSelectClient]="enableSelectClient()"
              [enableSelectApplication]="enableSelectApplication()"
              [enableButtonOptions]="enableButtonOptions()"
              [enableMenuOptions]="enableMenuOptions()"
              (event)="handleHistoryEvent(client, $event)"
              class="relative block">
            </oiq-client-application-history-table>
          </div>
          <div class="p-4">
            <h3 class="mb-2 font-medium">Fundings</h3>
            <oiq-client-funding-history-table
              [clientId]="_expandedElements[client.id] ? client.id : null"
              [enableSelectClient]="enableSelectClient()"
              [enableSelectFunding]="enableSelectFunding()"
              [enableButtonOptions]="enableButtonOptions()"
              [enableMenuOptions]="enableMenuOptions()"
              (event)="handleHistoryEvent(client, $event)"
              class="relative block">
            </oiq-client-funding-history-table>
          </div>
        </oiq-ui-panel>
      }
    }
  }
</div>
